// src/components/ui/dialogButtons.ts
//
// Clases estándar para los botones de los diálogos (formularios).
// Úsalas en el className de cada <Button> para mantener todos los
// diálogos consistentes. Si quieres cambiar el estilo global de los
// botones de diálogo, edita solo este archivo.
//
//   import { DLG_BTN_PRIMARY, DLG_BTN_SECONDARY } from '@/components/ui/dialogButtons';
//   <Button className={DLG_BTN_PRIMARY}>Guardar</Button>
//   <Button variant="outline" className={DLG_BTN_SECONDARY}>Cancelar</Button>
//
// Nota: los botones de diálogo van sobre superficies opacas (#1c1c1e),
// así que en modo oscuro usan color sólido, no vidrio translúcido.
// El efecto "glass" se reserva para botones sobre fondos con gradiente
// (ver Button variant="default").

// Base común: alto grande en móvil, algo más bajo en PC; redondeo medio.
const DLG_BTN_BASE =
  'h-12 sm:h-11 rounded-lg text-base sm:text-sm font-medium transition-colors';

// Primario — acción principal (Guardar, Usar, Siguiente…). Azul de marca.
export const DLG_BTN_PRIMARY =
  `${DLG_BTN_BASE} font-semibold text-white shadow-md ` +
  'bg-[#103254] hover:bg-[#0d2742] ' +
  'dark:bg-[#2d6b8f] dark:hover:bg-[#357ba3] dark:shadow-none ' +
  'dark:border dark:border-[#7fb0e0]/[0.35] ' +
  'disabled:opacity-50 disabled:cursor-not-allowed';

// Secundario — Cancelar / Volver / Atrás. Solo contorno, sin fondo.
export const DLG_BTN_SECONDARY =
  `${DLG_BTN_BASE} border border-gray-300 text-gray-700 hover:bg-gray-50 ` +
  'dark:border-white/[0.12] dark:text-gray-300 dark:bg-transparent ' +
  'dark:hover:bg-white/[0.05]';

// Destructivo — Eliminar / Salir sin guardar. Rojo.
export const DLG_BTN_DANGER =
  `${DLG_BTN_BASE} font-semibold text-white shadow-md ` +
  'bg-red-600 hover:bg-red-700 disabled:opacity-50';